import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px 5px',
    width: 220
  }
};

const enhance = compose(pure);

const button = enhance(({ classes, onClickAction }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      className={classes.button}
      onClick={onClickAction}
    >
      リスト形で表示
    </Button>
  );
});

export default withStyles(styles)(button);
